export default __webpack_public_path__ + "static/media/smedetoften-tenancy-11.7d760769.jpg";